/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UpsertRequestBody = {
  /**
   * User-friendly display name
   */
  displayName: string;
  /**
   * Original server name from hooks
   */
  rawServerName: string;
};

/** @internal */
export type UpsertRequestBody$Outbound = {
  display_name: string;
  raw_server_name: string;
};

/** @internal */
export const UpsertRequestBody$outboundSchema: z.ZodMiniType<
  UpsertRequestBody$Outbound,
  UpsertRequestBody
> = z.pipe(
  z.object({
    displayName: z.string(),
    rawServerName: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      displayName: "display_name",
      rawServerName: "raw_server_name",
    });
  }),
);

export function upsertRequestBodyToJSON(
  upsertRequestBody: UpsertRequestBody,
): string {
  return JSON.stringify(
    UpsertRequestBody$outboundSchema.parse(upsertRequestBody),
  );
}
